document.addEventListener('seremori:variant-change', event => {
  const product = event.target.closest('.product');
  if (!product) return;
  const { money, compareMoney, price, comparePrice } = event.detail;
  const onSale = Number(comparePrice) > Number(price);
  product.querySelectorAll('[data-sale-price]').forEach(display => {
    display.querySelector('[data-price]').textContent = money;
    display.querySelector('[data-sale-was]').textContent = compareMoney || '';
    display.querySelector('[data-sale-compare]').hidden = !onSale;
    display.querySelector('[data-sale-badge]').hidden = !onSale;
    if (onSale) display.querySelector('[data-sale-badge]').textContent = display.dataset.badgeTemplate.replace('[percent]', Math.round((comparePrice - price) / comparePrice * 100));
  });
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') document.querySelectorAll('.header__mobile-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
});
const initializePurchaseBar = () => {
  document.querySelectorAll('.mobile-purchase').forEach(bar => {
    if (bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const form = document.getElementById(bar.querySelector('a').hash.slice(1));
    bar.querySelector('a').addEventListener('click', event => {
      if (!form) return;
      event.preventDefault();
      form.scrollIntoView({ block:'start', behavior:'instant' });
      const heading = form.querySelector('h2');
      heading?.setAttribute('tabindex', '-1');
      heading?.focus({ preventScroll:true });
    });
    const actions = form?.querySelector('.brass-actions');
    if (actions) new IntersectionObserver(entries => bar.classList.toggle('is-obscured', entries[0].isIntersecting), { threshold: 0.1 }).observe(actions);
  });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializePurchaseBar, { once:true });
else initializePurchaseBar();
document.addEventListener('shopify:section:load', initializePurchaseBar);

let dispatchDateTimer;
const updateDispatchDates = () => {
  clearTimeout(dispatchDateTimer);
  const dates = document.querySelectorAll('[data-dispatch-date]');
  if (!dates.length) return;
  const today = new Date();
  const dispatch = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7, 12);
  const formattedDate = new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).format(dispatch);
  const isoDate = `${dispatch.getFullYear()}-${String(dispatch.getMonth() + 1).padStart(2, '0')}-${String(dispatch.getDate()).padStart(2, '0')}`;
  dates.forEach(date => {
    date.dateTime = isoDate;
    date.textContent = formattedDate;
  });
  const midnight = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
  dispatchDateTimer = setTimeout(updateDispatchDates, midnight - today + 1000);
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateDispatchDates, { once: true });
else updateDispatchDates();
window.addEventListener('pageshow', updateDispatchDates);
document.addEventListener('shopify:section:load', updateDispatchDates);
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) updateDispatchDates();
});
